
import Recaptcha from "../shared/Recaptcha.vue";
import Vue from "vue";
import moment from "moment";
import tarjeta from "@/components/visar/Tarjeta.vue";

export default Vue.extend({
  props: ["visado"],
  components: {
    tarjeta,
    Recaptcha
  },
  data() {
    return {
      recaptchaRequest: ""
    };
  },
  methods: {
    async visarMotivos() {
      this.$dialog.prompt({
        title: "Confirmar",
        message: `¿Estás seguro que quieres hacer un <strong>registro externo</strong>?`,
        cancelText: "Cerrar",
        confirmText: "Aceptar",
        type: "is-info",
        hasIcon: true,
        inputAttrs: {
          placeholder: "Motivo (Obligatorio)",
          type: "text",
          minLenght: 10,
          required: true
        },
        onConfirm: async val => {
          const datos = {
            motivo: val,
            idUser: this.visado.idUser,
            uuid: this.visado.uuid,
            keyRecaptcha: this.recaptchaRequest
          };

          this.$http
            .post("Registra/entrada", datos, {
              headers: {
                Authorization: `Bearer ${this.$store.state.jwt}`
              }
            })
            .then(res => {
              this.$toast.open({
                message: "Entrada registrada correctamente!",
                type: "is-success",
                position: "is-bottom"
              });

              this.visado.fechaEntada = moment().format();
              this.visado.motivo = val;
            })
            .catch(err => {
              this.$toast.open({
                message:
                  err.response.status != 500
                    ? err.response.data || "Error al registrar la entrada"
                    : "Error al registrar la entrada",
                type: "is-danger",
                position: "is-bottom"
              });
            });
        }
      });
    },
    setKeyRecaptcha(key: string) {
      this.recaptchaRequest = key;
    },
    visarIP() {
      this.$dialog.prompt({
        title: "Confirmar",
        message:
          "¿Estás seguro que quieres hacer un <strong>registro</strong>?",
        cancelText: "Cerrar",
        confirmText: "Aceptar",
        type: "is-info",
        hasIcon: true,
        inputAttrs: {
          placeholder: "Justificante (opcional)",
          type: "text",
          minLenght: 10,
          required: false
        },
        onConfirm: async val => {
          const datos = {
            idUser: this.visado.idUser,
            notaEntrada: val,
            uuid: this.visado.uuid,
            porIp: true,
            keyRecaptcha: this.recaptchaRequest
          };

          this.$http
            .post("Registra/entrada", datos, {
              headers: {
                Authorization: `Bearer ${this.$store.state.jwt}`
              }
            })
            .then(res => {
              const fecha = new Date();
              this.visado.fechaEntada = moment().format();
              this.visado.porIp = true;
              this.$toast.open({
                message: "Entrada registrada correctamente!",
                type: "is-success",
                position: "is-bottom"
              });
            })
            .catch(err => {
              this.$toast.open({
                message:
                  err.response.status != 500
                    ? err.response.data || "Error al registrar la entrada"
                    : "Error al registrar la entrada",
                type: "is-danger",
                position: "is-bottom"
              });
            });
        }
      });
    }
  }
});
